export default "__VITE_ASSET__BmAnBmIn__"